import { SvgProps } from './ic_portfolio';

export function IconMarket(props: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={25}
            height={24}
            fill="none"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.861 20.038a5.097 5.097 0 0 1-3.314-3.764.75.75 0 0 0-1.469.306 6.606 6.606 0 0 0 4.295 4.876.75.75 0 0 0 .488-1.418ZM17.545 3.926a5.098 5.098 0 0 1 3.313 3.764.749.749 0 1 0 1.468-.306 6.602 6.602 0 0 0-4.293-4.876.749.749 0 1 0-.488 1.418ZM7.791 14.948c.186.059.37-.085.383-.28.014-.213.04-.427.077-.635a7.84 7.84 0 0 1 6.56-6.56c.22-.039.44-.057.659-.07a.287.287 0 0 0 .263-.369c-.806-2.572-3.208-4.441-6.032-4.441-3.49 0-6.33 2.84-6.33 6.33 0 2.825 1.859 5.214 4.42 6.025Z"
                clipRule="evenodd"
            />
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.02 8.883c-.335 0-.67.018-1 .08a6.313 6.313 0 0 0-5.28 5.28c-.06.317-.08.662-.08 1a6.336 6.336 0 0 0 6.33 6.29c3.48 0 6.32-2.84 6.32-6.33 0-3.47-2.82-6.3-6.29-6.32Z"
                clipRule="evenodd"
            />
        </svg>
    );
}
